export function DataCard({ title, badge, rows, actions, onClick }) {
  const interactive = typeof onClick === "function";

  return (
    <div
      className="te-mobile-order-card"
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={interactive ? onClick : undefined}
      onKeyDown={
        interactive
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      style={interactive ? { cursor: "pointer" } : undefined}
    >
      <div className="te-mobile-order-card__header">
        <strong>{title}</strong>
        {badge ?? null}
      </div>
      {rows.map((row, index) => (
        <div key={`${row.label}-${index}`} className="te-mobile-order-card__row">
          <span className="te-muted">{row.label}</span>
          <span>{row.value}</span>
        </div>
      ))}
      {actions ? <div className="te-inline-actions">{actions}</div> : null}
    </div>
  );
}
